<script setup lang="ts">
import {computed, defineProps} from "vue"
const props = defineProps<{
    index: number,
    resultType: string | undefined,
    result: string,
    displayResult: string | undefined,
    copyResult: boolean,
    // reference: string | undefined,
    resultId: string | undefined,
    thumbnailUrl: string | undefined,
    selected: boolean,
}>()

const title = computed(() => {
    return props.copyResult || !props.displayResult ? props.result : props.displayResult
})

const url = computed(() => {
    if (props.resultType === "video"){
        return `/v/${props.resultId}`;
    }else if (props.result){
        return `/search/?q=${encodeURIComponent(props.result)}`
    }else{
        return ""
    }
})
</script>

<template>
    <li v-bind:key="index" :id="`result-${index}-${selected}`" :class="{'bg-mono-ps-100': selected}">
        <a :href="url" class="flex items-center gap-2">
            <img v-if="thumbnailUrl" class="w-10 h-10 object-cover" :src="thumbnailUrl">
            {{title}}
        </a>
    </li>
</template>
